import { Remarkable } from 'remarkable';
import Definition from '@/Pages/Asset/Contract/Definitions/Definition';
import Schedule from '@/Pages/Asset/Contract/Definitions/Schedule';

const md = new Remarkable();

export default {
  components: {
    Definition,
    Schedule,
  },

  props: {
    definitions: Array,
  },

  data() {
    return {
      schedule: false,
      scheduleReference: null,

      definition: false,
      definitionReference: null,
      definitionPosition: null,
    };
  },

  computed: {
    definitionContent() {
      return md.render(this.definitionReference.value);
    },

    scheduleContent() {
      return md.render(this.scheduleReference.value);
    },
  },

  methods: {
    handleClick(e) {
      if (e.target.matches('span.trigger')) {
        const type = e.target.getAttribute('data-type');

        this.$nextTick(() => {
          if (type === 'definition') {
            this.showDefinitionPopup(e);
          } else {
            this.showSchedulePanel(e);
          }
        });
      }
    },

    showDefinitionPopup(e) {
      this.removeArrow();

      // Find the position relative to the .contract
      const getOffsetTop = (element) => {
        let offsetTop = 0;
        while (element && !element.classList.contains('contract')) {
          offsetTop += element.offsetTop;
          // eslint-disable-next-line no-param-reassign
          element = element.offsetParent;
        }
        return offsetTop;
      };

      this.$nextTick(() => {
        // Find the reference
        this.definition = true;
        this.definitionReference = this.findDefinition(e.target.getAttribute('data-reference'));
        this.definitionPosition = getOffsetTop(e.target);
        e.target.classList.add('active');
      });
    },

    closeDefinitionPopup() {
      this.removeArrow();

      this.definition = false;
      this.definitionReference = null;
      this.definitionPosition = null;
      this.arrowPosition = null;
    },

    removeArrow() {
      const element = document.getElementsByClassName('a trigger active');
      if (element[0]) {
        element[0].classList.remove('active');
      }
    },

    showSchedulePanel(e) {
      this.schedule = true;
      this.scheduleReference = this.findDefinition(e.target.getAttribute('data-reference'));
    },

    findDefinition(reference) {
      return this.definitions.find((d) => d.id.toString() === reference.toString());
    },
  },

};
